// Chord Search Page - Dedicated rendering script
(function($) {
	'use strict';

	$(document).ready(function() {
		const $grid = $('.chord-grid');
		const chordNames = $grid.data('chords');

		if (!chordNames || !chordNames.length) {
			console.error('No chord names found');
			$('.loading-message').text('Error loading chords');
			return;
		}

		console.log('Loading', chordNames.length, 'chords via AJAX');

		// Load all chords via AJAX (from Redis cache)
		$.ajax({
			url: akordi_ajax.ajaxurl,
			type: 'POST',
			data: {
				action: 'load_classroom_chords',
				nonce: akordi_ajax.nonce,
				chords: chordNames
			},
			success: function(response) {
				if (response.success && response.data.chords) {
					const chords = response.data.chords;
					const source = response.data.source || 'unknown';
					console.log('Loaded', Object.keys(chords).length, 'classroom chords via', source);

					// Build HTML
					buildChordGrid(chords, chordNames);

					// Render with ChordJS
					if (typeof ChordJS !== 'undefined' && ChordJS.replace) {
						ChordJS.replace();
					}

					// Reveal content
					setTimeout(function() {
						$('.most-used-section').addClass('loaded');
						console.log('Chord Classroom: Rendering complete');
					}, 100);
				} else {
					console.error('Failed to load chords');
					$('.loading-message').text('Error loading chord library');
				}
			},
			error: function(xhr, status, error) {
				console.error('AJAX error:', error);
				$('.loading-message').text('Error loading chord library');
			}
		});

		// Build chord grid HTML from loaded chord data
		function buildChordGrid(chords, chordNames) {
			let html = '';
			let currentRoot = '';

			// Family name mappings for sharp notes
			const enharmonic = {
				'A#': 'A#/Bb',
				'C#': 'C#/Db',
				'D#': 'D#/Eb',
				'F#': 'F#/Gb',
				'G#': 'G#/Ab'
			};

			chordNames.forEach(function(chordName) {
				const variants = chords[chordName];
				if (!variants || !variants.length) return;

				// Get chord root (first character(s))
				const match = chordName.match(/^([A-G][#b]?)/);
				const chordRoot = match ? match[1] : '';

				// Add family header when root changes
				if (chordRoot && chordRoot !== currentRoot) {
					currentRoot = chordRoot;
					const familyDisplay = enharmonic[chordRoot] || chordRoot;
					html += '<div class="chord-family-header"><h3 class="family-title">' + familyDisplay + '</h3></div>';
				}

				// Get first variant
				const firstVariant = variants[0];
				const totalVariants = variants.length;

				// Format positions
				const hasDoubleDigit = firstVariant.positions.some(pos => pos !== 'x' && parseInt(pos, 10) >= 10);
				const positions = hasDoubleDigit ? firstVariant.positions.join('-') : firstVariant.positions.join('');
				const fingerings = firstVariant.fingerings[0] ? firstVariant.fingerings[0].join('').replace(/0/g, '-') : '------';

				// Build card HTML with variants stored for navigation
				html += '<div class="chord-card-wrapper">';
				html += '<div class="chord-card" data-chord-name="' + chordName + '" data-total-variants="' + totalVariants + '" data-current-variant="0">';
				html += '<div class="chord-header">';
				html += '<h3 class="chord-name color-white">' + chordName + '</h3>';

				if (totalVariants > 1) {
					html += '<span class="chord-variant-counter color-gray-600">1 of ' + totalVariants + '</span>';
				}

				html += '</div>';
				html += '<div class="chord-diagram">';
				html += '<chord name="" positions="' + positions + '" fingers="' + fingerings + '" size="3.5" layout="1" strings="EADGBe"></chord>';
				html += '</div>';

				if (totalVariants > 1) {
					html += '<div class="chord-nav-controls">';
					html += '<button class="chord-nav-prev" aria-label="Previous variation">‹</button>';
					html += '<button class="chord-nav-next" aria-label="Next variation">›</button>';
					html += '</div>';
				}

				html += '</div></div>';

				// Store variants in card for navigation (after HTML is inserted)
				setTimeout(function() {
					$('.chord-card[data-chord-name="' + chordName + '"]').data('loaded-variants', variants);
				}, 0);
			});

			$grid.html(html);
		}

		// Handle variant navigation (prev/next arrows)
		$(document).on('click', '.chord-nav-prev, .chord-nav-next', function(e) {
			e.preventDefault();

			const $card = $(this).closest('.chord-card');
			const chordName = $card.data('chord-name');
			const totalVariants = $card.data('total-variants');
			const currentVariant = $card.data('current-variant') || 0;
			const isNext = $(this).hasClass('chord-nav-next');

			// Calculate new variant index
			let newVariant;
			if (isNext) {
				newVariant = currentVariant < totalVariants - 1 ? currentVariant + 1 : 0;
			} else {
				newVariant = currentVariant > 0 ? currentVariant - 1 : totalVariants - 1;
			}

			// Get variants from stored data (already loaded on page load)
			const variants = $card.data('loaded-variants');

			if (variants) {
				renderVariant($card, variants, newVariant);
			} else {
				console.error('Variants not loaded for', chordName);
			}
		});

		// Helper function to render a variant
		function renderVariant($card, variants, variantIndex) {
			const variant = variants[variantIndex];
			const $diagram = $card.find('.chord-diagram');

			// Format positions and fingerings
			const hasDoubleDigit = variant.positions.some(pos => pos !== 'x' && parseInt(pos, 10) >= 10);
			const positions = hasDoubleDigit ? variant.positions.join('-') : variant.positions.join('');
			const fingerings = variant.fingerings[0] ? variant.fingerings[0].join('').replace(/0/g, '-') : '------';

			// Clear old chord
			$diagram.empty();

			// Render new variant
			$diagram.html('<chord name="" positions="' + positions + '" fingers="' + fingerings + '" size="3.5" layout="1" strings="EADGBe"></chord>');

			// Re-render only this card to avoid touching other chord variants.
			if (typeof ChordJS !== 'undefined' && ChordJS.replace) {
				ChordJS.replace($diagram[0]);
			}

			// Update counter
			$card.find('.chord-variant-counter').text((variantIndex + 1) + ' of ' + variants.length);

			// Update current variant
			$card.data('current-variant', variantIndex);
		}
	});

})(jQuery);
